import React from "react";
import styles from "./styles.module.scss";

const MovementWrapper = ({ children, id="" }) => {
  return <div id={id} className={styles.movementWrapper}>{children}</div>;
};

export default MovementWrapper;
